<!--
  - Copyright (c) 2022.
  - Dev owner: Sedov A Sergey
  - Contact: sedov.sergey@isnlab.com
  -->

<template>
  <li class="submenu-item">
    <router-link class="submenu-link" :to="route">
      {{text}}
    </router-link>
  </li>
</template>

<script>
export default {
  name: 'SubItem',
  props : {
    route : Object,
    text : String,
  },
}
</script>